import { Provider } from 'react-redux'
import './i18n/i18n'
import store from './redux/store'
import Router from './router'

function App () {
  return (
    <Provider store={store}>
      <Router/>
    </Provider>
  )
}

export default App
